<template>
  <!-- :mini-variant.sync="drawer" -->
  <v-navigation-drawer
    color="primary"
    v-model="drawer"
    app
    clipped
    left
    style="top: 64px; max-height: calc(100% - 64px)"
  >
    <v-list dense dark>
      <div v-for="route in routes" :key="route.id">
        <router-link
          :to="{ name: route.route }"
          class="navigation-a-underline--remove"
        >
          <v-list-item
            :class="currentSelection === route.id ? 'primary lighten-1' : ''"
          >
            <v-list-item-action>
              <v-icon>{{ route.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ route.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </div>
    </v-list>
    <v-list dense dark v-if="!loading && canUseKnowledgeBaseBtn">
      <v-list-item @click="handleHelp">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title
            >{{ $t("components.navigationBar.builderBar.help") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <powered-by-sentinel :is-navbar="true" />
    </template>
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
import PoweredBySentinel from "../banners/PoweredBySentinel.vue";

export default {
  name: "navigation",
  components: {
    HelpDialog,
    PoweredBySentinel,
  },
  data: () => ({
    canUseKnowledgeBaseBtn: false,
    helpDialog: { location: null, active: false },
    drawer: null,
    loading: true,
    routes: [],
    currentSelection: null,
    // mini: true,
  }),

  created() {
    this.setInitalData();
    this.canUseKnowledgeBaseBtn = constraints.canUseKnowledgeBaseBtn("builder");

    let getMenuAccess = null;
    if (Object.keys(this.getMe).length === 0) {
      getMenuAccess = this.$store.dispatch(USER_CRM_REQUEST);
    } else {
      getMenuAccess = new Promise((resolve, reject) => {
        resolve(this.getMe);
      });
    }

    getMenuAccess.then((resp) => {
      this.routes = this.routes.filter((item) => {
        return resp.menu_access[item.id].visible;
      });

      const route = this.routes.find((element) => {
        return element.id === this.$route.meta.menu;
      });

      if (typeof route === "undefined") {
        console.error(
          "Builder route is undefined",
          JSON.stringify(resp.menu_access)
        );
      }

      this.currentSelection = route.id;
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters(["getDrawerStatus", "getMe"]),
  },

  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }
    });
  },

  watch: {
    drawer(val) {
      if (this.getDrawerStatus !== this.drawer) {
        this.$store.commit("COLLAPSED", val);
      }
    },
    $route(curr, old) {
      this.setCurrentRoute();
    },
  },

  methods: {
    setInitalData() {
      this.routes = [
        {
          id: "boats",
          name: this.$t("components.navigationBar.builderBar.boats"),
          route: "boats",
          icon: "mdi-sail-boat",
        },
        {
          id: "models",
          name: this.$t("components.navigationBar.builderBar.models"),
          route: "models",
          icon: "mdi-ferry",
        },
        {
          id: "documents",
          name: this.$t("components.navigationBar.builderBar.documents"),
          route: "documents",
          icon: "mdi-file-document-edit-outline",
        },
        {
          id: "items",
          name: this.$t("components.navigationBar.builderBar.parts"),
          route: "items",
          icon: "mdi-folder-multiple",
        },
      ];
    },

    setCurrentRoute() {
      const route = this.routes.find((element) => {
        return element.id === this.$route.meta.menu;
      });

      this.currentSelection = route.id;
    },
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "builder";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
